import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";
import { ALLOWED_MODULES } from "../../constants/enums";

const RevenueReport = Loadable(
  lazy(() =>
    import("./RevenueReport/RevenueReport").then(({ RevenueReport }) => ({
      default: RevenueReport,
    })),
  ),
);

const MarginReport = Loadable(
  lazy(() =>
    import("./MarginReport/MarginReport").then(({ MarginReport }) => ({
      default: MarginReport,
    })),
  ),
);

const RoomReport = Loadable(
  lazy(() =>
    import("./RoomReport/RoomReport").then(({ RoomReport }) => ({
      default: RoomReport,
    })),
  ),
);

const OwnerSummaryReport = Loadable(
  lazy(() =>
    import("./OwnerSummaryReport/OwnerSummaryReport").then(
      ({ OwnerSummaryReport }) => ({
        default: OwnerSummaryReport,
      }),
    ),
  ),
);

const LeadsReport = Loadable(
  lazy(() =>
    import("./LeadsReport/LeadsReport").then(({ LeadsReport }) => ({
      default: LeadsReport,
    })),
  ),
);

const CancellationReport = Loadable(
  lazy(() =>
    import("./CancellationReport/CancellationReport").then(
      ({ default: CancellationReport }) => ({
        default: CancellationReport,
      }),
    ),
  ),
);

const GuestVisitReport = Loadable(
  lazy(() =>
    import("./GuestListReport/GuestListReport").then(
      ({ default: GuestListReport }) => ({
        default: GuestListReport,
      }),
    ),
  ),
);

const OnGoingList = Loadable(
  lazy(() =>
    import("./OnGoingList/OnGoingList").then(({ default: OnGoingList }) => ({
      default: OnGoingList,
    })),
  ),
);

const DailySummery = Loadable(
  lazy(() =>
    import("./DailySummery/DailySummery").then(({ default: DailySummery }) => ({
      default: DailySummery,
    })),
  ),
);

const WeeklySummery = Loadable(
  lazy(() =>
    import("./WeeklySummery/WeeklySummery").then(
      ({ default: WeeklySummery }) => ({
        default: WeeklySummery,
      }),
    ),
  ),
);

const EmployeePerformanceReport = Loadable(
  lazy(() =>
    import("./EmployeePerformanceReport/EmployeePerformanceReport").then(
      ({ default: EmployeePerformanceReport }) => ({
        default: EmployeePerformanceReport,
      }),
    ),
  ),
);

const VenuePerformanceOverview = Loadable(
  lazy(() =>
    import("./VenuePerformanceOverview/VenuePerformanceOverview").then(
      ({ default: VenuePerformanceOverview }) => ({
        default: VenuePerformanceOverview,
      }),
    ),
  ),
);

const TodaysFollowups = Loadable(
  lazy(() =>
    import("./TodaysFollowups/TodaysFollowups").then(({ default: TodaysFollowups }) => ({
      default: TodaysFollowups,
    })),
  ),
);

const EmployeeLeadFollowupReport = Loadable(
  lazy(() =>
    import("./EmployeeLeadFollowupReport/EmployeeLeadFollowupReport").then(
      ({ default: EmployeeLeadFollowupReport }) => ({
        default: EmployeeLeadFollowupReport,
      }),
    ),
  ),
);

export const ReportRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.reports.revenueReport,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.REVENUE_REPORT]}>
        <RevenueReport />
      </AuthorizedRoute>
    ),
  },

  {
    path: REACT_APP_NAV_ROUTES.reports.marginReport,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MARGIN_REPORT]}>
        <MarginReport />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.roomReport,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ROOM_REPORT]}>
        <RoomReport />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.ownerSummaryReport,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.OWNER_SUMMARY]}>
        <OwnerSummaryReport />
      </AuthorizedRoute>
    ),
  },

  {
    path: REACT_APP_NAV_ROUTES.reports.leadsReport,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.LEADS_SUMMARY]}>
        <LeadsReport />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.cancellationReport,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CANCELLATION_REPORT]}>
        <CancellationReport />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.guestVisitReport,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.GUEST_VISIT_REPORT]}>
        <GuestVisitReport />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.onGoingList,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ONGOING_REPORT]}>
        <OnGoingList />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.dailySummery,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.DAILY_SUMMARY_REPORT]}>
        <DailySummery />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.weeklySummery,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.WEEKLY_SUMMARY_REPORT]}>
        <WeeklySummery />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.employeePerformanceReport,
    exact: true,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.EMPLOYEE_PERFORMANCE_REPORT]}
      >
        <EmployeePerformanceReport />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.venuePerformanceOverview,
    exact: true,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.VENUE_CALENDAR]}
      >
        <VenuePerformanceOverview />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.todaysFollowups,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.TODAYS_FOLLOWUPS]}>
        <TodaysFollowups />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.reports.employeeLeadFollowupReport,
    exact: true,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.EMPLOYEE_LEAD_FOLLOWUP_REPORT]}
      >
        <EmployeeLeadFollowupReport />
      </AuthorizedRoute>
    ),
  },
];
